"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E3F3FD",
  d: "M2 4h8l1.5 1.5H22V20H2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#198FDE",
  fillRule: "evenodd",
  d: "M1.3 4a.7.7 0 0 1 .7-.7h7.879a.7.7 0 0 1 .482.193l1.818 1.732h9.82a.7.7 0 0 1 .7.7V20a.7.7 0 0 1-.7.7H2a.7.7 0 0 1-.7-.7zm1.4.7v14.6h18.6V6.625h-9.401a.7.7 0 0 1-.483-.193L9.599 4.7z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#198FDE",
  fillRule: "evenodd",
  d: "M10.644 9.99a1.355 1.355 0 0 0-1.9 0 1.307 1.307 0 0 0 0 1.864 1.355 1.355 0 0 0 1.9 0 1.31 1.31 0 0 0 0-1.865M7.9 9.136a2.555 2.555 0 0 1 3.59 0 2.51 2.51 0 0 1 0 3.57 2.555 2.555 0 0 1-3.59 0 2.51 2.51 0 0 1 0-3.57m7.67 1.046a.798.798 0 1 0-1.128 1.128.798.798 0 0 0 1.128-1.128m-1.977-.848a1.998 1.998 0 1 1 2.825 2.824 1.998 1.998 0 0 1-2.825-2.824m2.81 5.072h-2.096a.6.6 0 0 1 0-1.2h2.096c1.104 0 1.998.894 1.998 1.997a.6.6 0 0 1-1.2 0 .8.8 0 0 0-.798-.797m-8.65.713a.945.945 0 0 0-.952.938v.442a.6.6 0 1 1-1.2 0v-.442c0-1.186.97-2.137 2.153-2.137h3.882c1.183 0 2.153.95 2.153 2.137v.442a.6.6 0 0 1-1.2 0v-.442a.945.945 0 0 0-.953-.937z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkspacesColorIcon24.js.map